jQuery(function($) {
	$(function() {
		var $toggle = $(".nav-toggle");
		var $hamburger = $(".site-hamburger-nav");
		var $header = $(".site-header");
		var $body = $("body");
		var $hbody = $("html,body");
		var $layer = $("#fadeLayer");
		var $parent = $(".menu-item-has-children");
		var $parent_a = $(".menu-item-has-children > a");
		var $parent_span = $(".menu-item-has-children > .toggle-children-item");
		var $parent_current = $(".current-menu-parent");
		var $ancestor_current = $(".current-menu-ancestor");
		var scrollTop = 0;
		var $parent_first = $("#hamburger-global-menu > li > a");

		// Nav Toggle Button
		$toggle.click(function() {
			$hamburger.toggleClass("open");
			$header.toggleClass("open");
			$toggle.toggleClass("open");

			if ($body.hasClass("no-scroll")) {
				$body.css({ position: "static", top: "0" });
				$hbody.scrollTop(scrollTop);
				$layer.css({ visibility: "hidden" });
				$body.removeClass("no-scroll");
			} else {
				scrollTop = $(window).scrollTop();
				$body.css({ position: "fixed", top: -scrollTop });
				$layer.css({ visibility: "visible" });
				$body.addClass("no-scroll");
			}
		});

		//Resize Event
		$(window).resize(function() {
			var w = $(window).width(); //画面のwidthを取得

			if (w > 720) {
				if ($hamburger.hasClass("open")) {
					$hamburger.removeClass("open");
				}
				if ($header.hasClass("open")) {
					$header.removeClass("open");
				}
				if ($toggle.hasClass("open")) {
					$toggle.removeClass("open");
				}
				if ($body.hasClass("no-scroll")) {
					$body.css({ position: "static", top: "0" });
					$hbody.scrollTop(scrollTop);
					$layer.css({ visibility: "hidden" });
					$body.removeClass("no-scroll");
				}
			}
		});

		//// Nav Show Control
		//Initialize
		$(window).load(function() {
			$parent_current.addClass("show");
			$ancestor_current.addClass("show");
		});
		//Clicked Action
		$parent_span.click(function() {
			$(this).toggleClass("open");
			$(this)
				.parent()
				.toggleClass("show");
			// $parent.addClass('show');
			// if ($(this).hasClass('open')) {
			// 	$(this).removeClass('open');
			// }
			// 	$parent.removeClass('show');
			// }
		});
		$parent_first.click(function() {
			$(this)
				.next(".toggle-children-item")
				.toggleClass("open");
			$(this)
				.parent()
				.toggleClass("show");
		});
	});
});
